import React from "react";

/**
 * Catches uncaught render errors so users see a friendly message
 * instead of a completely blank page.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Log for debugging in production browser console
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = "/login";
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    const msg = this.state.error?.message || String(this.state.error);
    return (
      <div
        data-testid="error-boundary"
        className="min-h-screen flex items-center justify-center bg-[#050B1F] text-white p-6"
      >
        <div className="max-w-md w-full border border-white/[0.08] bg-[#0A1738]/60 backdrop-blur-md rounded-md p-8">
          <div className="font-geist-mono text-[10px] tracking-widest uppercase text-[#4D8AFF] mb-2">
            error · unexpected
          </div>
          <h1 className="font-geist text-2xl font-semibold mb-4">
            Qualcosa è andato storto
          </h1>
          <p className="text-sm text-white/60 mb-4 leading-relaxed">
            L'app ha incontrato un errore inatteso. Il team è stato notificato
            (controlla la console del browser per dettagli).
          </p>
          <div className="font-geist-mono text-[11px] text-red-300 border border-red-400/30 bg-red-500/10 rounded-sm px-3 py-2 break-all mb-4">
            {msg}
          </div>
          <button
            data-testid="error-boundary-reset"
            onClick={this.handleReset}
            className="w-full h-11 rounded-sm bg-[#4D8AFF] hover:bg-[#75A6FF] text-[#050B1F] font-geist font-semibold"
          >
            Torna al login
          </button>
        </div>
      </div>
    );
  }
}
